import { DELETE, GET, POST, PUT } from '../utils/crud'

export const listCoordinatingStaff = async (filters = {}) => {
  const params = new URLSearchParams()
  Object.keys(filters).forEach((key) => {
    const value = filters[key]
    if (value !== undefined && value !== null && value !== '')
      params.append(key, value)
  })
  const query = params.toString()
  return await GET(`coordinating-staff${query ? `?${query}` : ''}`)
}

export const showCoordinatingStaff = async (id) =>
  await GET(`coordinating-staff/${id}`)

export const createCoordinatingStaff = async (body) =>
  await POST('coordinating-staff', body)

export const updateCoordinatingStaff = async (id, body) =>
  await PUT(`coordinating-staff/${id}`, body)

export const deleteCoordinatingStaff = async (id) =>
  await DELETE(`coordinating-staff/${id}`)
